<template>
    <div>
        <!-- tabla 3 -->
        <v-card  v-if="mostrar_ayuda"
            class="pl-6 pr-6 help-modal"
            elevation="24"
        >
            <v-card-text>
                <div>
                    <table class="helpp" width="100%">
                        <thead>
                            <tr>
                                <th width="25%"></th>
                                <th width="25%"></th>
                                <th width="25%"></th>
                                <th width="25%"></th>
                            </tr>
                            <tr>
                                <th width="100%" colspan="4" class="help-modal__th">
                                    <h2 class="help-modal__title"> {{ registros[0].titulo}} </h2>
                                    <v-btn color="green" class="help-modal__btn-close" dark @click="mostrar_ayuda=false">Cerrar</v-btn>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(fila,idx) in registros" :key="idx">
                                <td :class="`${fila.tipo == 'imgtexto' ? 'help-modal__td--bordered' : 'help-modal__td'} ${fila.align ? fila.align : 'text-left'}`" :colspan="fila.tipo == 'imgtexto' ? fila.cols : 4">

                                    <h3 v-if="fila.tipo == 'titulo1'">{{fila.texto}}</h3>
                                    <h4 v-if="fila.tipo == 'titulo2'">{{fila.texto}}</h4>
                                    <p v-if="fila.tipo == 'titulo3'"><span><bold>{{fila.bold}}</bold></span><span>{{fila.texto}}</span></p>
                                    <label for="" v-if="fila.tipo == 'label' " class="help-modal__label">
                                        <template v-if="typeof fila.texto === 'string'">
                                            {{ fila.texto }}
                                        </template>
                                        <template v-else>
                                            <template v-for="(texto, idx) in fila.texto.labels">
                                                {{ texto }}
                                                <img v-if="fila.texto.imgs[idx]"
                                                    :src="`${base_url.replace('api/','')}archivos/ayudas/${fila.texto.imgs[idx].url}`"
                                                    contain
                                                    :width="!!fila.texto.imgs[idx].width ? fila.texto.imgs[idx].width : ''"
                                                    :height="!!fila.texto.imgs[idx].height ? fila.texto.imgs[idx].height : ''"
                                                    class="help-modal__img_inline"
                                                >
                                            </template>
                                        </template>
                                    </label>

                                    <v-img v-if="(fila.tipo == 'imagen') || (fila.tipo == 'imgtexto')"
                                            :src="`${base_url.replace('api/','')}archivos/ayudas/${fila.url}`"
                                            :aspect-ratio="fila.ratio"
                                            contain
                                            @click="() => showImg(fila.url)"
                                            :style="{cursor: 'pointer'}"
                                            title="Ver imagen"
                                            class="color-ayuda img-ayuda ma-3 pa-0"
                                    ></v-img>
                                    <v-tooltip top color="blue darken-4" v-if="fila.tipo=='tooltip'">
                                        <template>
                                            <v-btn icon v-on="on">
                                            <v-icon color="blue darken-1">info</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{fila.texto}}</span>
                                    </v-tooltip>
                                </td>

                                <td class="text-left pl-1 help-modal__td" v-if="fila.tipo == 'imgtexto'" :colspan="(4 - parseInt(fila.cols))">
                                    <label for="" v-if="fila.tipo == 'imgtexto' ">{{fila.texto}}</label>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </v-card-text>
        </v-card>
        <v-dialog
            v-model="dialog"
            width="auto"
            >
            <v-card>
                <v-card-text>
                    <v-img
                        :src="`${base_url.replace('api/','')}archivos/ayudas/${current_url}`"
                        contain
                        min-width="500px"
                        class="color-ayuda img-ayuda ma-3 pa-0"
                    ></v-img>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
// import axios from 'axios'
import {mapState,mapMutations} from 'vuex';
export default {
    data:()=>({
        mostrar_ayuda:false,
        registros:[],
        current_url: "",
        dialog: false,
    }),
    beforeDestroy() {
        Event.$off('mostrar_alert');
    },
    mounted() {
        Event.$on('mostrar_alert',(conf)=>{
            //this.registros = conf;
            this.registros = conf.map(registro => {
                if(!registro.texto) {
                    return registro;
                }
                const registroSplitted = registro.texto.split("insert_img_");
                if(registroSplitted.length === 1) {
                    return registro;
                }
                const newTexto = {
                    labels: [],
                    imgs: [],
                };
                registroSplitted.forEach((label, idx) => {
                    if(idx == 0) {
                        newTexto.labels.push(label);
                        return;
                    }
                    const labelSplitted = label.split(" ");
                    
                    const img = labelSplitted[0].split("?");
                    const newImg = {};
                    img.forEach((img, idx) => {
                        if(idx == 0) {
                            newImg.url = img;
                            return;
                        }
                        const imgSplitted = img.split("="); 
                        newImg[imgSplitted[0]] = imgSplitted[1];
                    });

                    newTexto.imgs.push(newImg);
                    newTexto.labels.push(label.replace(labelSplitted[0], ""));
                });
                registro.texto = newTexto;
                return registro;
            });
            if (this.mostrar_ayuda) {
                this.mostrar_ayuda = false;
            } else {
                this.mostrar_ayuda = true;
            }
        });
    },
    methods: {
        showImg(url) {
            this.current_url = url;
            this.dialog = true;
        },
        ...mapMutations(['mostrarLoading','ocultarLoading']),
    },
    computed:{
        ...mapState(['base_url','headers'])       
    },
    components:{
    },
}
</script>
<style scoped>
.help-modal__btn-close {
    position: absolute;
    top: 1rem;
    right: 1rem;
}
.help-modal__th {
    background-color: #FFEBA0 !important;
    border: 0;
}
.help-modal{
    background-color: #FFEBA0;
    position: relative;
}
.help-modal__img_inline {
    border: 2px solid green;
    border-radius: 10px;
    transform: translateY(10px);
}
.help-modal__td--bordered {
    border-right: 1px solid green;
}
.help-modal__td {
    border: 0;
}
.img-ayuda{
    margin-bottom: 2px !important;
    margin-top: 2px !important;
    border-bottom: 3px groove green;
    border-top : 3px ridge green;
    border-radius: 10px;
}
.border{
    border: 1px solid #333;
    border-collapse: collapse;
}
.helpp{
    border-spacing: 0px;
    display: inline-table; /*key*/
}
.help-modal__title{
    text-decoration: underline double purple;
    padding: 1rem 0;
    color: #00000099;
    font-size: 21px;
}
</style>